const INSURANCE_TYPES=['legal','private','public'];export default INSURANCE_TYPES;